import React, { useContext, useEffect, useState } from "react";
import { Box, Button, darken, Modal, styled } from "@mui/material";
import { useTranslation } from "react-i18next";
import { AuthContext } from "../../Auth";
import WhmcsApi from "../../services/WhmcsApi";
import ic_timer from "../../images/icon/ic-countdown-timer.svg";
import ExpiredSessionLogin from "./ExpiredSessionLogin";
import { useLocation } from "react-router-dom";

// estilos secciones del componente
const ModalContent = styled(Modal)(() => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  padding: "1rem",
}));

const ModalBody = styled(Box)(() => ({
  outline: "none",
  background: "#ffffff",
  borderRadius: "8px",
  padding: "3rem 2rem",
  width: "100%",
  maxWidth: "400px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
}));

const Icon = styled("img")(() => ({
  maxWidth: "70px",
  marginBottom: "2.5rem",
}));

const TextTitle = styled("p")(() => ({
  fontFamily: "Patua One",
  fontSize: "18px",
  fontWeight: 400,
  lineHeight: "20px",
  textAlign: "center",
  marginBottom: "1rem",
}));

const Text = styled("p")(() => ({
  fontFamily: "Roboto",
  fontSize: "14px",
  fontWeight: 300,
  lineHeight: "20px",
  textAlign: "center",
  marginBottom: 0,
}));

const ButtonCustom = styled(Button)(() => ({
  backgroundColor: "#2287B8",
  fontFamily: "Patua One",
  fontSize: "16px",
  fontWeight: 400,
  lineHeight: "24px",
  marginTop: "2rem",
  textTransform: "initial",
  "&:hover": {
    backgroundColor: darken("#2287B8", "0.15"),
  },
}));

// componente principal
const ExpiredSession = () => {
  const [openLogin, setOpenLogin] = useState(false);
  const [showCloseModalLogin, setShowCloseModalLogin] = useState(true);
  const { t } = useTranslation();
  const { userAuth, logout, showLoginExpired, setShowLoginExpired } = useContext(AuthContext);
  const location = useLocation();

  const handleClickButton = () => {
    setShowLoginExpired(false);
    setOpenLogin(true);
  };

  const handleCloseLogin = () => {
    setOpenLogin(false);
  };

  useEffect(() => {
    /**
     * validamos si el modal de login lo puede cerrar el usuario
     * Existen vistas que no tienen el menu en el header para iniciar sesión
     * ni tampoco se contempla una vista para contenido bloqueado por sesión
     * lo cual deja una vista casi vacía, se opto por dejar siempre visible el login
     */
    const bloquearCierreModalLogin = () => {
      // se divide la url por segmentos
      const partsURL = location.pathname.split("/");
      // debido que el pathname siempre comienza en /, la posición 0 siempre estará vacía
      // si existe la posición 1 en el array
      if (partsURL[1] !== undefined) {
        // si la url contiene checkout, y existe otra sub ruta
        if (partsURL[1] === "checkout" && partsURL[2] !== undefined) {
          switch (partsURL[2]) {
            // sub-rutas de checkout que necesitan bloquear el cierre de login
            case "spei":
            case "paypalplus":
            case "evo":
            case "saf":
            case "oxxo":
              setShowCloseModalLogin(false);
              break;
            default:
              break;
          }
        }
      }
    };

    bloquearCierreModalLogin();
  }, [location?.pathname]);

  useEffect(() => {
    let intervaloConsultaSession = null;

    const validateSessionActive = async () => {
      const whmcsApi = new WhmcsApi(); // Crear instancia de WhmcsApi
      const response = await whmcsApi.request("validateSessionActive", {}, "POST", userAuth?.token);

      // si la session esta inactiva
      if (response.result === "error") {
        setShowLoginExpired(true);
      }
    };

    // solo creamos el intervalo si existe una sesión en react y que el modal no sea visible
    if (userAuth && !showLoginExpired) {
      intervaloConsultaSession = setInterval(() => {
        validateSessionActive();
      }, 60_000); // valida cada minuto
    }

    // si el modal se muestra
    if (showLoginExpired || openLogin) {
      logout(); // limpiamos la sesion
      clearInterval(intervaloConsultaSession); // cancelamos el intervalo de consulta de session
    }

    return () => {
      clearInterval(intervaloConsultaSession);
    };
  }, [userAuth, showLoginExpired, openLogin]);

  return (
    <>
      <ModalContent open={showLoginExpired} disableEscapeKeyDown>
        <ModalBody boxShadow={24}>
          <Icon src={ic_timer} alt="icono reloj" />

          <TextTitle>{t("session_expired.title")}</TextTitle>

          <Text>{t("session_expired.text1")}</Text>
          <Text>{t("session_expired.text2")}</Text>

          <ButtonCustom variant="contained" onClick={handleClickButton}>
            {t("session_expired.btn")}
          </ButtonCustom>
        </ModalBody>
      </ModalContent>

      <ExpiredSessionLogin open={openLogin} onClose={handleCloseLogin} showCloseModalLogin={showCloseModalLogin} logout={logout} />
    </>
  );
};

export default ExpiredSession;
